const pad = (value) => String(value).padStart(2, '0')
const day = (value) => `${pad(value.getDate())}.${pad(value.getMonth() + 1)}.${value.getFullYear()}`

export function defaultHistoryRange(now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6)
  return `${day(start)} - ${day(now)}`
}

export function parseHistoryRange(value) {
  const match = value.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})\s*-\s*(\d{2})\.(\d{2})\.(\d{4})$/)
  if (!match) return null
  const start = new Date(+match[3], +match[2] - 1, +match[1])
  const end = new Date(+match[6], +match[5] - 1, +match[4], 23, 59, 59, 999)
  if (start.getDate() !== +match[1] || start.getMonth() !== +match[2] - 1 || start.getFullYear() !== +match[3]
    || end.getDate() !== +match[4] || end.getMonth() !== +match[5] - 1 || end.getFullYear() !== +match[6] || start > end) return null
  return { from: start.toISOString(), to: end.toISOString() }
}

export function configurationFuelGrades(configuration) {
  const rows = Array.isArray(configuration?.FuelGrades) ? configuration.FuelGrades : []
  const seen = new Set()
  return rows.filter((row) => {
    if (!Number.isInteger(row?.Id) || row.Id < 1 || row.Id > 10 || seen.has(row.Id)) return false
    seen.add(row.Id)
    return true
  }).map((row) => ({ fuelGradeId: row.Id, name: typeof row.Name === 'string' ? row.Name : null,
    confirmedPrice: typeof row.Price === 'number' && Number.isFinite(row.Price) && row.Price >= 0 ? String(row.Price) : null,
  })).sort((a, b) => a.fuelGradeId - b.fuelGradeId)
}

export function configurationPumpIds(configuration) {
  const rows = configuration?.Pumps?.Pumps ?? configuration?.Pumps
  return [...new Set((Array.isArray(rows) ? rows : []).map((row) => row?.Id)
    .filter((id) => Number.isInteger(id) && id >= 1 && id <= 100))].sort((a, b) => a - b)
}

export function tagInventoryMessage(inventory) {
  if (inventory?.state === 'COMPLETE') return `Читання тегів завершено. Отримано: ${inventory.observedCount ?? 0}.`
  if (inventory?.state === 'RUNNING') return 'Виконується читання тегів із контролера. Для перевірки результату натисніть «Оновити».'
  if (inventory?.state === 'PARTIAL') return 'Читання тегів перервано. Список може бути неповним; це не підтверджує відсутність тегів. Повторна спроба — лише через «Оновити».'
  return 'Повноту списку тегів не підтверджено. Натисніть «Оновити», щоб перевірити стан читання.'
}
